/* Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved. */

export const albumPages = {
    AlbumDetailPage: () => import('@/album/AlbumDetailPage'),
}
